import c from "./index273.js";
import { resolveComponent as r, createElementBlock as t, openBlock as o, createCommentVNode as s, createVNode as a, createElementVNode as d, renderSlot as n, withCtx as p } from "vue";
import m from "./index231.js";
const h = ["data-component"], f = {
  key: 0,
  class: "mb-4 text-color-neutral-grey-60 text-caption-desktop"
}, u = {
  key: 0,
  class: "mb-16"
}, k = {
  key: 1,
  class: "mb-24 line-clamp-3"
}, _ = { class: "flex items-center justify-between mt-auto font-bold text-text-l-desktop" }, $ = {
  key: 0,
  class: "flex items-center group-hover:underline"
}, w = {
  key: 1,
  class: "flex items-center justify-center w-32 h-32 overflow-hidden rounded-full bg-color-brand-yellow-50"
};
function g(e, y, b, v, C, N) {
  const l = r("ms-click-area"), i = r("ms-arrow-right");
  return o(), t("div", {
    "data-component": e.$options.name,
    class: "relative flex flex-col justify-between p-16 transition-shadow border shadow hyphens rounded-10 hover:shadow-hover group"
  }, [
    e.$slots.caption ? (o(), t("span", f, [
      n(e.$slots, "caption")
    ])) : s("", !0),
    a(l, {
      href: e.link.url,
      target: e.link.target,
      rel: e.link.rel,
      trackingData: e.trackingData
    }, {
      default: p(() => [
        e.$slots.headline ? (o(), t("div", u, [
          n(e.$slots, "headline")
        ])) : s("", !0)
      ]),
      _: 3
    }, 8, ["href", "target", "rel", "trackingData"]),
    e.$slots.text ? (o(), t("span", k, [
      n(e.$slots, "text")
    ])) : s("", !0),
    d("span", _, [
      e.$slots.linkText ? (o(), t("span", $, [
        a(i, { class: "w-24 h-24 mr-8" }),
        n(e.$slots, "linkText")
      ])) : s("", !0),
      e.$slots.icon ? (o(), t("span", w, [
        n(e.$slots, "icon")
      ])) : s("", !0)
    ])
  ], 8, h);
}
const x = /* @__PURE__ */ m(c, [["render", g]]);
export {
  x as default
};
